<div class="elevated-container" *transloco="let t">
  @if (loaded()) {
    <div class="found-places-message-container">
      <img ngSrc="assets/images/mail.png" alt="mail" height="106" width="106">
      <div class="places-counter">{{32 | loyaltyNumber}}</div>
    </div>
    <div class="text">{{t('placesSearch.foundText', {foundPlaces: 32 | loyaltyNumber})}}</div>
    <button mat-flat-button class="button-medium loyalty" routerLink="/onboarding">
      {{t('placesSearch.buttonText')}}
    </button>
  } @else {
    <app-loader></app-loader>
    <div class="text">{{t('placesSearch.searchingText')}}</div>
  }
</div>
